import React, { useEffect } from "react";
import { Formik } from "formik";
import { EagerPasswordInput } from "components/forms/PasswordInput";
import TextInput from "components/forms/TextInput";
import { Button, Container, FormContainer } from "./styles";
// import { loginValidation } from "utils/validationSchema";
import CssLoading from "components/cssloading";
// import { Link } from "react-router-dom";
import { userLogin } from "./requests";
import { AuthContext } from "App";
import Cookies from "js-cookie";
import doToast from "components/toast/doToast";
import { useMutation } from "react-query";
import useSessionStorage from "hooks/useSessionStorage";

// import { userLogin } from "services/queries/auth";

const defaultValues = {
  email: "",
  password: ""
};

function Login(props) {
  const { history } = props;
  const { setUser } = React.useContext(AuthContext);

  const mutation = useMutation({
    mutationKey: ["login"],
    mutationFn: body => userLogin(body)
  });

  async function handleSubmit(values, setSubmitting) {
    // let encoded = new Buffer.from(values.password, "binary").toString("base64");

    mutation.mutate(values);
    setSubmitting(false);
  }

  const { setItem } = useSessionStorage();

  useEffect(() => {
    if (mutation.data) {
      doToast("Logged in successfully", "success");
      // console.log(mutation.data);

      setUser(mutation.data.data);
      Cookies.set("token", mutation.data?.data?.jwt_token, { secure: true, expires: 0.04 });
      Cookies.set("username", mutation.data?.data?.name, { secure: true });
      Cookies.set("userId", mutation.data.data?.id, { secure: true });
      Cookies.set("clientId", mutation.data.data?.client_id, { secure: true });
      setItem("userRoles", mutation?.data?.data?.roles);

      setTimeout(() => {
        history?.push("/");
      }, 0);
    }
    if (mutation.error) {
      doToast(mutation?.error?.response?.data?.message ?? "Oops! An error occurred", "error");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mutation.data, mutation.error]);

  return (
    <Container>
      <FormContainer>
        <h2>VAS Dashboard</h2>
        <h3>Login</h3>
        <Formik
          initialValues={defaultValues}
          // validate={loginValidation}
          onSubmit={(values, { setSubmitting }) => handleSubmit(values, setSubmitting)}
        >
          {({ isSubmitting, handleSubmit }) => (
            <>
              <form onSubmit={handleSubmit}>
                <TextInput
                  name="email"
                  label="Email"
                  placeholder="Email"
                  type="text"
                  autocomplete="email"
                  maxLength="256"
                />
                <EagerPasswordInput
                  name="password"
                  label="Password"
                  placeholder="Enter your password"
                  maxLength="256"
                />
                <div style={{ height: 16 }} />

                <Button type="submit" disabled={isSubmitting}>
                  {mutation?.isLoading ? <CssLoading /> : "Log me In"}
                </Button>

                {/* <footer>
                  <p>
                    Don’t have an account? <Link to="/register">Create one</Link>
                  </p>
                </footer> */}
              </form>
            </>
          )}
        </Formik>
      </FormContainer>
    </Container>
  );
}

export default Login;
